import {
  GET_MATCH_CARD_HEADER_REQUEST,
  GET_MATCH_CARD_HEADER_SUCCESS,
  GET_MATCH_CARD_HEADER_FAILURE,
  GET_MATCH_CARD_HEADER_STATISTICS_SUCCESS,
  RESET_MATCH_CARD,
  LIVE_SCORES_WS_UPDATE
} from 'Store/constants';
import {
  updateWithSocketMessage,
} from 'Utils/updateWithSocketScoreBoard';

const initialState = {
  data: {},
  isLoading: null,
  isFetched: false,
  error: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_MATCH_CARD_HEADER_REQUEST:
      return { ...state, isLoading: true, error: null };

    case GET_MATCH_CARD_HEADER_SUCCESS:
      return { ...state, data: { ...action.payload }, isLoading: false, isFetched: true, error: null };

    case GET_MATCH_CARD_HEADER_FAILURE:
      return { ...state, isLoading: false, isFetched: true, error: action.payload };

    case GET_MATCH_CARD_HEADER_STATISTICS_SUCCESS: {
      const incoming = action.payload.statistics;
      const hasData = incoming?.homeStats != null && incoming?.awayStats != null;
      return {
        ...state,
        data: {
          ...state.data,
          statistics: hasData ? incoming : state.data.statistics,
        },
      };
    }

    case LIVE_SCORES_WS_UPDATE: {
      if (state.error) return state;

      const { payload: { value } } = action;

      if (value.sbsEventId === state.data.matchCode) {
        return updateWithSocketMessage(state, value);
      }

      return state;
    }

    case RESET_MATCH_CARD:
      return { ...initialState };

    default:
      return state;
  }
};
